import fallbackAvatar from '@/assets/img/examples/avatar-fake.jpg';

function withCacheBuster(url, cacheBuster) {
    if (!cacheBuster) return url;
    try {
        const parsedUrl = new URL(url, window.location.origin);
        parsedUrl.searchParams.set('v', String(cacheBuster));
        return parsedUrl.toString();
    } catch (e) {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}v=${encodeURIComponent(String(cacheBuster))}`;
    }
}

export function buildDiscourseAvatarUrl(avatarTemplate, size = 52, cacheBuster = null) {
    try {
        if (!avatarTemplate || typeof avatarTemplate !== 'string') {
            return fallbackAvatar;
        }

        const base = import.meta.env.VITE_DISCOURSE_API_URL || '';
        if (!base) {
            return fallbackAvatar;
        }

        let baseUrl;
        try {
            baseUrl = new URL(base);
        } catch (e) {
            return fallbackAvatar;
        }

        let path = String(avatarTemplate);

        path = path.replace('{size}', String(size));
        path = path.replace('{hostname}', baseUrl.hostname);

        if (path.startsWith('//')) {
            return `https:${path}`;
        }

        if (path.startsWith('http://') || path.startsWith('https://')) {
            return path;
        }

        const basePath = baseUrl.pathname.replace(/\/$/, '');
        
        if (path.startsWith(basePath)) {
            path = path.substring(basePath.length);
        }
        
        const relPath = path.startsWith('/') ? path : `/${path}`;
        const finalPath = `${basePath}${relPath}`;
        
        const fullUrl = `${baseUrl.origin}${finalPath}`;
        return withCacheBuster(fullUrl, cacheBuster);
    } catch (error) {
        return fallbackAvatar;
    }
}
